// src/reducers/attendanceReportReducer.js

import {
    FETCH_ATTENDANCE_REPORT_SUCCESS,
    FETCH_ATTENDANCE_REPORT_FAIL,
  } from '../actions/attendanceReportActions';
  
  const initialState = {
    report: [],
    error: null,
  };
  
  const attendanceReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ATTENDANCE_REPORT_SUCCESS:
        return { ...state, report: action.payload, error: null };
      case FETCH_ATTENDANCE_REPORT_FAIL:
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };
  
  export default attendanceReportReducer;
  